/**
 * Atalho global do Localizador.
 *
 * ⌘K estava reservado por escrito desde o Sprint Visual Brief 2A — o
 * `KeyboardShortcutsModal` o listava como «Busca rápida», indisponível.
 *
 * Não colide com nada do que já existe: `⌘/` é o painel de atalhos, `⌘N` é
 * iniciar conversa, `/` é a busca local da Inbox, `⌘R` é reassumir condução.
 *
 * O `k` exige modificador. Sem isso, digitar «k» em qualquer campo de texto do
 * app abriria a paleta por cima do que o operador está escrevendo.
 */
import { useEffect, useState } from 'react';

export function useSpotlightOpen(): { open: boolean; setOpen: (v: boolean) => void } {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent): void => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setOpen((v) => !v);
        return;
      }
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return { open, setOpen };
}
